export const GetFooterPolicies = () => {
    return ([{"id":"af79d7e9-5247-4fea-8dfa-321ebd37f130","title":"Privacy Policy","permalink":"/policy"}])
}